import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import currentUserReducer from './currentUser/currentUserSlice';
import paymentFormReducer from './paymentForm/paymentFormSlice';
import { persistConfig } from './persistConfig';
import settingsReduces from './settingsSlice';
import uiReducer from './ui/uiSlice';

const reducers = combineReducers({
  ui: uiReducer,
  currentUser: currentUserReducer,
  settings: settingsReduces,
  paymentForm: paymentFormReducer
});

// Creates a persistedReducer by wrapping the root reducer with persistConfig
const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer, // Use the persisted reducer
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  // Other store configuration options go here...
});

// Create a persistor object for rehydration
const persistor = persistStore(store);

// Export both the store and the persistor
export { store, persistor };
